import React from 'react';

const FormSelect = React.memo(({ label, options, value, setValue }) => {
  const id = label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className='flex flex-col space-y-1'>
      <label htmlFor={id} className='block text-sm font-medium text-gray-700 dark:text-gray-300'>
        {label}
      </label>
      <select
        id={id}
        name={id}
        className='block w-full py-1.5 pl-3 pr-10 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700'
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
        }}
      >
        {options.map((option, index) => (
          <option key={index}>{option}</option>
        ))}
      </select>
    </div>
  );
});

FormSelect.displayName = 'FormSelect';

export default FormSelect;
